import { KICK_REPORT_TEMPLATE_FILTER_VALUE } from "@common/constants/reports/report-settings-template";

export const getReportTemplateFilterKey = (templateId: string | null) =>
    templateId ?? KICK_REPORT_TEMPLATE_FILTER_VALUE;
